import React from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';

interface PdfViewerProps {
  pdfUrl: string;
  height?: string | number;
  title?: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ pdfUrl, height = '100%', title }) => {
  if (!pdfUrl) {
    return (
      <Box
        style={{
          height,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <CircularProgress size={48} />
      </Box>
    );
  }

  return (
    <Box style={{ height, width: '100%', display: 'flex', flexDirection: 'column' }}>
      <iframe
        src={pdfUrl}
        title={title || 'PDF Document'}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          flexGrow: 1
        }}
      />
    </Box>
  );
};

export default PdfViewer;
